"use strict";

(function () {
  'use strict';

  angular.module('lr.Transactions').factory('Transactions', ['$http', 'api', 'User', '$q', 'authErrors', function ($http, api, User, $q, authErrors) {
    var Transactions = {};

    Transactions.getActual = function (args) {
      var deferred = $q.defer();

      if (User.isAuthenticated()) {
        var adminCustDataID = User.getToken().AdminCustDataID;
        var sendData = {
          queryDate: args.date
        };
        $http.post(api.proxy + '/Reservations/Transaction/Turnover/actual', sendData).then(function (data) {
          deferred.resolve(data);
        }, function (data) {
          deferred.reject(data);
        });
      } else {
        deferred.reject(authErrors.notAuthenticated);
      }

      return deferred.promise;
    };
    /**
     *
     * @param args
     * @returns {*}
     */


    Transactions.getTurnoverData = function (args) {
      var deferred = $q.defer();

      if (User.isAuthenticated()) {
        var adminCustDataID = User.getToken().AdminCustDataID;
        var sendData = {
          queryDate: args.date
        };
        $http.post(api.proxy + '/Reservations/Transaction/Turnover/expected', sendData).then(function (data) {
          deferred.resolve(data);
        }, function (data) {
          deferred.reject(data);
        });
      } else {
        deferred.reject(authErrors.notAuthenticated);
      }

      return deferred.promise;
    };

    return Transactions;
  }]);
})();